import { useState } from "react";

import Hamburger from "hamburger-react";
import { AccountApiNS as NS } from "~types/api/account";

import { Box } from "@mui/material";

export default function TopMenu(props: {
  splashPage: NS.GetSplashPageInfoResponse;
}) {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <Box
      className="py-3 text-lg sticky top-0 z-50 shadow-sm"
      sx={{ background: props.splashPage.top_menu_bg_color }}>
      <Box className="desktop-menu hidden md:flex container gap-6 mx-auto items-center">
        <div>
          {props.splashPage.logo_img && (
            <img
              src={props.splashPage.logo_img}
              style={{
                objectFit: "contain",
                width: "auto",
                height: "32px"
              }}
              alt="logo"
            />
          )}
        </div>
        <div className="flex gap-6 justify-end pl-20">
          {props.splashPage.top_menu_items?.map((item, index) => (
            <Box
              component={"a"}
              className="h-full px-4 py-2 flex items-center rounded-md"
              key={index}
              href={item.url}
              target={item.open_tab ? "_blank" : "_self"}
              sx={{
                backgroundColor: props.splashPage.top_menu_bg_color,
                color: props.splashPage.top_menu_text_color,
                "&:hover": {
                  backgroundColor: props.splashPage.top_menu_hover_color
                }
              }}>
              {item.label}
            </Box>
          ))}
        </div>
        <div className="flex grow justify-end">
          {props.splashPage.show_top_menu_button &&
            props.splashPage.top_menu_button_link &&
            props.splashPage.top_menu_button_text && (
              <Box
                component={"a"}
                className="text-lg font-semibold px-4 py-2 flex items-center rounded-md"
                href={props.splashPage.top_menu_button_link}
                target={
                  props.splashPage.top_menu_button_link ? "_blank" : "_self"
                }
                sx={{
                  backgroundColor: props.splashPage.top_menu_button_bg_color,
                  color: props.splashPage.top_menu_button_text_color,
                  "&:hover": {
                    backgroundColor:
                      props.splashPage.top_menu_button_hover_color
                  }
                }}>
                {props.splashPage.top_menu_button_text}
              </Box>
            )}
        </div>
      </Box>
      <Box className="mobile-menu md:hidden flex flex-col">
        <Box className="flex items-center pl-2 justify-between">
          <div className="grow max-w-[140px]">
            {props.splashPage.logo_img && (
              <img
                src={props.splashPage.logo_img}
                style={{
                  objectFit: "contain",
                  width: "auto",
                  height: "48px"
                }}
                alt="logo"
              />
            )}
          </div>
          <div className="md:hidden flex justify-center items-center pl-2">
            {props.splashPage.show_top_menu_button &&
              props.splashPage.top_menu_button_link &&
              props.splashPage.top_menu_button_text && (
                <Box
                  component={"a"}
                  className="max-w-[200px] text-sm font-semibold px-2 py-3 flex items-center rounded-md"
                  href={props.splashPage.top_menu_button_link}
                  target={
                    props.splashPage.top_menu_button_link ? "_blank" : "_self"
                  }
                  sx={{
                    backgroundColor: props.splashPage.top_menu_button_bg_color,
                    color: props.splashPage.top_menu_button_text_color,
                    "&:hover": {
                      backgroundColor:
                        props.splashPage.top_menu_button_hover_color
                    }
                  }}
                  onClick={() => setIsMenuOpen(false)}>
                  {props.splashPage.top_menu_button_text}
                </Box>
              )}
          </div>
          <div className="w-12">
            <Hamburger
              size={24}
              toggled={isMenuOpen}
              onToggle={isOpen => {
                setIsMenuOpen(isOpen);
              }}
            />
          </div>
        </Box>
        <div
          className={`
            transition-all duration-300 ease-in-out overflow-hidden
            ${isMenuOpen ? "max-h-96 opacity-100 pt-4" : "max-h-0 opacity-0"}
          `}>
          {props.splashPage.top_menu_items?.map((item, index) => (
            <Box
              component={"a"}
              className="h-full px-2 py-2 flex items-center text-lg font-bold"
              key={index}
              href={item.url}
              target={item.open_tab ? "_blank" : "_self"}
              sx={{
                backgroundColor: props.splashPage.top_menu_bg_color,
                color: props.splashPage.top_menu_text_color,
                "&:hover": {
                  backgroundColor: props.splashPage.top_menu_hover_color
                }
              }}
              onClick={() => setIsMenuOpen(false)}>
              {item.label}
            </Box>
          ))}
        </div>
      </Box>
    </Box>
  );
}
